<template>
  <Modal
    v-if="renderModal"
    :modal-title="'Allmänna villkor'"
    :show-modal="showModal"
    @close-modal="toggleModal"
  >
    <MxsGdpr v-if="modalContent === 'gdpr-mxs'" />
    <CustomerGdpr v-if="modalContent === 'gdpr-company'" :company="profile" />
  </Modal>

  <div class="text-sm md:text-md mt-2 block">
    <label :for="id" data-dashlane-label="true">
      <div class="relative">
        <input
          class="disabled:bg-gray-1 disabled:hover:text-gray-1 disabled:text-text-gray-1 disabled:cursor-not-allowed disabled:border-gray-1"
          type="checkbox"
          v-model="model.data"
          @change="customChange"
          :id="id"
          :disabled="props.disabled ? true : null"
        />

        <span
          class="px-2"
          :id="'inner-text_' + model.key"
          v-if="model.isHtml"
          v-html="model.label"
        ></span>
        <span class="px-2" :id="'inner-text_' + model.key" v-if="!model.isHtml">
          {{ model.label }}
        </span>
        <div
          :id="'icon-error_' + model.key"
          class="hidden absolute top-[3px] right-0 left-auto w-[20px] flex flex-row justify-center items-center"
          @mouseenter="showErrorMessage"
          @mouseleave="hideErrorMessage"
        >
          <i class="text-red-2 fa-solid fa-circle-info"></i>
        </div>
      </div>
      <div v-show="showingErrorMessage" class="relative z-50">
        <div
          class="absolute top-0 left-0 right-0 bottom-auto bg-white rounded-md p-2 shadow-md"
          :id="'outer-error_' + model.key"
        >
          <p
            class="font-medium text-sm text-red-2"
            :id="'error_' + model.key"
          ></p>
        </div>
      </div>
    </label>
  </div>
</template>
<script setup lang="ts">
import { defineProps, onMounted, ref } from "vue";
import { defineEmits } from "@vue/runtime-core";
import { useStore } from "vuex";
import { ContainerResponse } from "@/models/dtos";
import { Profile } from "@/models/Profile";
import { MainContainer } from "@/models/MainContainer";
import MxsGdpr from "@/features/agreements/components/MxsGdpr.vue";
import CustomerGdpr from "@/features/agreements/components/CustomerGdpr.vue";
import Modal from "@/features/shared/components/ui/Modal.vue";
const emit = defineEmits(["change"]);
const store = useStore();
const props = defineProps({
  model: {
    required: true,
  },
  id: String,
  label: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  renderModal: {
    required: false,
    type: Boolean,
    default: true,
  },
});
let model = ref(props.model);
const showModal = ref(false);
const modalContent = ref("");
const toggleModal = () => {
  showModal.value = !showModal.value;
};
const profile = ref<Profile>();

function test(e: any) {}
function customChange(event: any) {
  emit("change", model.value);
  //
}

const showingErrorMessage = ref(false);

const showErrorMessage = () => {
  showingErrorMessage.value = true;
};
const hideErrorMessage = () => {
  showingErrorMessage.value = false;
};

onMounted(() => {
  if (model.value.label.includes("term01")) {
    const el = document.getElementById("term01");
    if (el !== null) {
      el.removeEventListener("click", term01);
      el.addEventListener("click", term01);
    }
  }
  if (model.value.label.includes("term02")) {
    const el = document.getElementById("term02");
    if (el !== null) {
      el.removeEventListener("click", term02);
      el.addEventListener("click", term02);
    }
  }
});
function term02() {
  modalContent.value = "gdpr-mxs";
  toggleModal();
}
function term01() {
  profile.value = new Profile(new MainContainer(store.getters.container));
  if (!profile.value.DisplayName.data) {
    profile.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
  }
  modalContent.value = "gdpr-company";
  let _id = (store.getters.container as ContainerResponse).id;

  if (!_id) {
    _id = (store.getters.publicContainer as ContainerResponse).id;
  }
  if (_id) {
    toggleModal();
  }
}
</script>
